'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002423 from "./presto.-Login-Page-View$$anon$23.js";
import * as $j_presto$002etypes$0024$002dLogin$002dMode$0024 from "./presto.types$-Login-Mode$.js";
import * as $j_presto$002etypes$0024$002dSaml$002dId$0024 from "./presto.types$-Saml-Id$.js";
import * as $j_presto$002etypes$0024$002dSaml$002dName$0024 from "./presto.types$-Saml-Name$.js";
import * as $j_presto$002etypes$0024proto$0024$002dGet$002dProvider$002dResponse$0024 from "./presto.types$proto$-Get-Provider-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$22() {
  this.b6u = null;
  this.b6m = null;
  this.b6n = false;
  this.b6v = null;
  this.b6w = false;
  this.b6z = null;
  this.b6s = null;
  this.b6t = false;
  this.b6o = null;
  this.b6p = false;
  this.b6q = null;
  this.b6r = false;
  this.b6x = false;
  this.b6y = false;
  this.b6u = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b6z = "GetProviderResponse";
}
export { $c_Lpresto_LoginPageView$$anon$22 as $c_Lpresto_LoginPageView$$anon$22 };
$p = $c_Lpresto_LoginPageView$$anon$22.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$22;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$22() {
}
export { $h_Lpresto_LoginPageView$$anon$22 as $h_Lpresto_LoginPageView$$anon$22 };
$h_Lpresto_LoginPageView$$anon$22.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.b6u;
});
$p.L = (function() {
  if ((!this.b6n)) {
    this.b6m = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b6n = true;
  }
  return this.b6m;
});
$p.O = (function() {
  if ((!this.b6w)) {
    this.b6v = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b6w = true;
  }
  return this.b6v;
});
$p.E = (function() {
  return this.b6z;
});
$p.t = (function() {
  if ((!this.b6t)) {
    this.b6s = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("type", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b6t = true;
  }
  return this.b6s;
});
$p.M = (function() {
  if ((!this.b6p)) {
    this.b6o = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dLogin$002dMode$0024.$m_Lpresto_types$LoginMode$().cHS(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dSaml$002dId$0024.$m_Lpresto_types$SamlId$().cHU())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dSaml$002dName$0024.$m_Lpresto_types$SamlName$().cHV())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b6p = true;
  }
  return this.b6o;
});
$p.Q = (function() {
  if ((!this.b6r)) {
    this.b6q = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002423.$c_Lpresto_LoginPageView$$anon$23();
    this.b6r = true;
  }
  return this.b6q;
});
$p.w = (function() {
  if ((!this.b6y)) {
    this.b6x = false;
    this.b6y = true;
  }
  return this.b6x;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee148) => ((p) => \u03b4scrutinee148.cGU(p)))($j_presto$002etypes$0024proto$0024$002dGet$002dProvider$002dResponse$0024.$m_Lpresto_types$proto$GetProviderResponse$())));
});
var $d_Lpresto_LoginPageView$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$22, "presto.LoginPageView$$anon$22", ({
  Me: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$22 as $d_Lpresto_LoginPageView$$anon$22 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$22.js.map
